// assets/bundle-child-guard.js
(function () {
  const CACHE_KEY = "bb_blocked_variant_ids_cache_v2";
  const CACHE_TTL_MS = 10 * 1000; // 10sn

  function now() { return Date.now(); }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js alınamadı");
    return res.json();
  }

  function isBundleChildLine(item) {
    const props = item && item.properties ? item.properties : null;
    if (!props) return false;
    return String(props._bundle_child || props["_bundle_child"] || "").toLowerCase() === "true";
  }

  function readCache() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;
      if (!parsed.t || !Array.isArray(parsed.ids)) return null;
      if (now() - parsed.t > CACHE_TTL_MS) return null;
      return new Set(parsed.ids.map(Number).filter(Number.isFinite));
    } catch {
      return null;
    }
  }

  function writeCache(idsSet) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        t: now(),
        ids: Array.from(idsSet)
      }));
    } catch {}
  }

  async function getBlockedVariantIds() {
    const cached = readCache();
    if (cached) return cached;

    const cart = await fetchCart();
    const set = new Set();

    (cart.items || []).forEach((it) => {
      if (isBundleChildLine(it)) {
        const vid = Number(it.variant_id);
        if (Number.isFinite(vid)) set.add(vid);
      }
    });

    writeCache(set);
    return set;
  }

  function showMessage(variantId) {
    // toast kullanıyorsan burayı değiştir
    alert("Bu ürün bundle içinde sepette zaten var. Bundle üzerinden düzenleyebilirsin.");
  }

  function parseBodyToObject(body) {
    if (!body) return null;

    // JSON string olabilir
    if (typeof body === "string") {
      try { return JSON.parse(body); } catch {}
      // form-urlencoded olabilir
      try {
        const params = new URLSearchParams(body);
        const obj = {};
        params.forEach((v, k) => { obj[k] = v; });
        return obj;
      } catch {}
      return null;
    }

    // FormData olabilir
    if (body instanceof FormData) {
      const obj = {};
      body.forEach((v, k) => { obj[k] = v; });
      return obj;
    }

    // object (fetch JSON)
    if (typeof body === "object") return body;

    return null;
  }

  function extractVariantIdsFromPayload(payload) {
    const ids = [];
    if (!payload) return ids;

    // { items: [{id, quantity}, ...] }
    if (Array.isArray(payload.items)) {
      payload.items.forEach((x) => {
        const id = Number(x && x.id);
        if (Number.isFinite(id)) ids.push(id);
      });
    }

    // { id: 123 } veya form-urlencoded id=123
    if (payload.id != null) {
      const id = Number(payload.id);
      if (Number.isFinite(id)) ids.push(id);
    } else if (payload["id"] != null) {
      const id = Number(payload["id"]);
      if (Number.isFinite(id)) ids.push(id);
    }

    return ids;
  }

  async function shouldBlockAdd(variantIds) {
    if (!variantIds || !variantIds.length) return { block: false };
    const blocked = await getBlockedVariantIds();

    const hit = variantIds.find((id) => blocked.has(Number(id)));
    if (hit) return { block: true, variantId: Number(hit) };

    return { block: false };
  }

  function fakeOkResponse() {
    // bazı temalar response.json bekler, bozulmasın
    return new Response(JSON.stringify({ blocked: true }), {
      status: 200,
      headers: { "Content-Type": "application/json" }
    });
  }

  // --- 1) FORM SUBMIT (ürün sayfası klasik) ---
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form || form.tagName !== "FORM") return;

    const action = (form.getAttribute("action") || "").toLowerCase();
    if (!action.includes("/cart/add")) return;

    const idInput = form.querySelector('[name="id"]');
    const variantId = idInput ? Number(idInput.value) : NaN;
    if (!Number.isFinite(variantId)) return;

    try {
      const result = await shouldBlockAdd([variantId]);
      if (result.block) {
        e.preventDefault();
        e.stopPropagation();
        showMessage(result.variantId);
      }
    } catch {}
  }, true);

  // --- 2) FETCH INTERCEPT (AJAX add) ---
  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const method = (init && init.method ? init.method : "GET").toUpperCase();
    const isAdd = url.includes("/cart/add") || url.includes("/cart/add.js");

    if (!isAdd || method !== "POST") {
      return _fetch.apply(this, arguments);
    }

    try {
      const payload = parseBodyToObject(init && init.body);
      const ids = extractVariantIdsFromPayload(payload);

      const result = await shouldBlockAdd(ids);
      if (result.block) {
        showMessage(result.variantId);
        return fakeOkResponse();
      }
    } catch (e) {
      // hata olursa normal akış
      return _fetch.apply(this, arguments);
    }

    const res = await _fetch.apply(this, arguments);

    // cart değişti, cache temizle
    try { sessionStorage.removeItem(CACHE_KEY); } catch {}

    return res;
  };

  // --- 3) XHR INTERCEPT (bazı temalar) ---
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bb_url = url;
    this.__bb_method = method;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = async function (body) {
    try {
      const url = String(this.__bb_url || "");
      const method = String(this.__bb_method || "GET").toUpperCase();
      const isAdd = url.includes("/cart/add") || url.includes("/cart/add.js");

      if (isAdd && method === "POST") {
        const payload = parseBodyToObject(body);
        const ids = extractVariantIdsFromPayload(payload);

        const result = await shouldBlockAdd(ids);
        if (result.block) {
          showMessage(result.variantId);
          try { this.abort(); } catch {}
          return;
        }
      }
    } catch {}

    return _send.apply(this, arguments);
  };

})();
